import $ from "jquery";
//import Modernizr from "modernizr";
// import Swiper JS
import Swiper from "swiper/bundle";
// import Swiper styles
import "swiper/css";

const jQuery = $;
// Namespace
var UNC = UNC || {};

// Tell the DOM that JS is enabled
document.body.className += " js-enabled";

// Detect for Mouse vs. Keyboard events for accessibility helpers
document.addEventListener("keydown", function (e) {
	if (e.keyCode === 9) {
		jQuery("html").addClass("keyboard-user");
	}
});

document.addEventListener("mousedown", function (e) {
	jQuery("html").removeClass("keyboard-user");
});

// Amimate Sections when scrolled into view
UNC.animateSections = (function ($) {
	function init() {
		var $section_animation_elements = $("main#main > section");
		var $window = $(window);

		function check_if_in_view() {
			var window_height = $window.height();
			var window_top_position = $window.scrollTop();
			var window_bottom_position = window_top_position + window_height;

			$.each($section_animation_elements, function () {
				var $element = $(this);
				var element_height = $element.outerHeight();
				var element_top_position = $element.offset().top;
				var element_bottom_position = element_top_position + element_height;
				var element_stat = $(this).find(".timer");

				// check to see if this current container is within viewport
				if (element_bottom_position >= window_top_position && element_top_position <= window_bottom_position) {
					$element.addClass("in-view");
				}
			});
		}

		$window.on("scroll resize", check_if_in_view);
		$window.trigger("scroll");
	}

	if ($("section").length) {
		init();
	}
})(jQuery);

// Accessibility Helpers
UNC.accessibiliytHelpers = (function ($) {
	// Remove focus from third-party iframe video players (delay for iframe loaded through js)
	setTimeout(function () {
		if ($("iframe.youtube").length) {
			$("iframe.youtube").each(function () {
				$(this).attr("tabindex", "-1");
			});
		}
	}, 3000);

	// Highlights section, add appropriate Aria Label for Terms
	if ($("section.news_topic_highlights").length) {
		$("section.news_topic_highlights .terms a").each(function () {
			$(this).attr("aria-label", "Related articles for " + $(this).text());
		});
	}
})(jQuery);

// Post Headlines, Prevent single words alone on one line
UNC.postHeadlines = (function ($) {
	function init() {
		$("section.post header h1").each(function () {
			var wordArray = $(this).text().split(" ");
			if (wordArray.length > 1) {
				//http://justinhileman.info/article/a-jquery-widont-snippet/
				$(this).html(
					$(this)
						.html()
						.replace(/\s([^\s<]+)\s*$/, "&nbsp;$1")
				);
			}
		});
	}

	if ($("section.post header h1").length) {
		init();
	}
})(jQuery);

// Story Page, Pause Ambient video
UNC.storyVideo = (function ($) {
	function init() {
		var $storyMedia = $("body.story-template-default .background_media_title .media");
		var $storyVideo = $storyMedia.find("video")[0];
		var $storyVideoPauseBtn = $storyMedia.find(".pause");

		// If local storage is set to 'paused', stop the video autoplay, and update button
		// shares setting with homepage video
		if (localStorage.getItem("videoHomeHero") === "paused") {
			$storyVideoPauseBtn.addClass("paused").text("Play Video");
			$storyVideo.pause();
		}

		// Video Pause button for ambient video playing above nav
		if ($storyMedia.length) {
			$storyVideoPauseBtn.on("click", function (e) {
				e.preventDefault();
				if (!$(this).is(".paused")) {
					$(this).addClass("paused").text("Play Video");
					$storyVideo.pause();
					localStorage.setItem("videoHomeHero", "paused");
				} else {
					$(this).removeClass("paused").text("Pause Video");
					$storyVideo.play();
					localStorage.setItem("videoHomeHero", "playing");
				}
			});
		}
	}

	if ($("body.story-template-default #story_experience_video").length) {
		init();
	}
})(jQuery);

// Social Media Directory, Accordion Menu
UNC.socialMediaDirectory = (function ($) {
	function init() {
		var $container = $(".social_media_directory");
		var $accordionMenu = $container.find(".account-list");
		var $accrodionButtons = $accordionMenu.find("> li > button");

		$accrodionButtons.on("click", function (e) {
			e.preventDefault();

			if (!$(this).is(".active")) {
				$(this).addClass("active").attr("aria-expanded", "true");
				$(this).next().slideDown(250);
			} else {
				$(this).removeClass("active").attr("aria-expanded", "false");
				$(this).next().slideUp(250);
			}
		});
	}

	if ($(".social_media_directory").length) {
		init();
	}
})(jQuery);

UNC.homePageCookieNotice = (function ($) {
	var $notice = $("body.home #unc-cookies-notification");

	function init() {
		if ($notice.css("position") == "absolute") {
			var $win = $(window);
			var hdr = $("#unc-experience-header")[0];

			$win.bind("scroll.homePageCookieNotice", function () {
				var rect = hdr.getBoundingClientRect();
				if (rect.bottom <= 0) {
					$notice.addClass("is-shown");
					$win.unbind("scroll.homePageCookieNotice");
				}
			});
		}
	}

	if ($notice.length) {
		init();
	}
})(jQuery);

// Define vars
var unc_active_tab = false,
	unc_date_pickers = [],
	unc_infinite_scrollers = [],
	unc_google_maps = [],
	unc_google_maps_center = [],
	unc_google_maps_markers = [],
	unc_google_maps_bounds = [],
	unc_google_maps_info_windows = [],
	unc_fixed_on_scroll = [],
	unc_swipers = [],
	unc_youtube_players = [];

jQuery(document).ready(function ($) {
	if (typeof highlight_and_share !== "undefined") {
		if (typeof highlight_and_share.email_url !== "undefined") {
			highlight_and_share.email_url = "mailto:?Subject=%title%&body=%text% %url%";
			$("body")
				.off("click", ".has_email a")
				.on("click", ".has_email a", function (e) {
					var selectedText = window.getSelection();
					var text = selectedText.toString();
					this.href = this.href.replace("%text%", encodeURIComponent('"' + text + '"'));
					$(".highlight-and-share-wrapper:visible").remove();
					window.location.href = this.href;
					e.preventDefault();
					e.stopPropagation();
					return false;
				});
		}
	}

	/**
	 * Clear Form
	 */
	$("form#unc-form").each(function () {
		var $form = $(this);

		$form.find("select").each(function () {
			if ($(this).val() !== "-1") {
				$form.find(".clear-all").addClass("show");
			}
		});

		// show clear all button
		$("select, input").on("change", function () {
			$(".clear-all").addClass("show");
		});

		$(".btn-clear").on("click", function () {
			// reset value of select to the first element
			$("select").prop("selectedIndex", 0);
			// clear value for start and end date on date inputs
			$(".start_date, .end_date").attr("value", "");
			$(".date-range span").text("").append("Date Range");
			$("#tribe-bar-search").val("");
			// hide clear all button
			$(".clear-all").removeClass("show");
		});

		// submit form
		$("#submit").on("click", function () {
			$("#unc-form").submit();
		});
	});

	// Chaptered Navigation
	UNC.navChapters = (function () {
		var namespace = "navChapters";
		var $chapteredNav = $("section.chaptered_page .nav-chapters-container");

		var init = function () {
			var $window = $(window);

			var $container = $(".nav-chapters-container");
			var $chaptersContainer = $(".chapters-container");
			var $navMenu = $container.find("ul");
			var $navLink = $container.find("ul > li > a:not(.external-link)");
			var offset = 140;
			var menuPosition = 140;
			var stickyNavTop;
			var $menuToggle = $container.find(".handle");
			var navHeight = $navMenu.outerHeight();

			// stick nav to fixed/absolute position
			var set_nav_position = function () {
				// window vars
				var windowHeight = $window.height();
				var windowTopPosition = $window.scrollTop();
				var windowBottomPosition = windowTopPosition + windowHeight;

				// footer vars
				var $chaptersEnd = $("#chapters-end");
				var navPosition = $navMenu.offset().top;
				var chaptersEndPosition = $chaptersEnd.offset().top;

				// remove "fixed" position if footer is visible, and add "bottom" class
				if (navPosition + navHeight > chaptersEndPosition) {
					$chapteredNav.addClass("bottom");
				}

				// if footer is not visible, remove "bottom" class
				else {
					$chapteredNav.removeClass("bottom");

					// remove/add "fixed" - check to see if near offset top
					if ($window.scrollTop() > stickyNavTop) {
						$chapteredNav.addClass("fixed");
					} else {
						$chapteredNav.removeClass("fixed");
					}
				}

				// update chapters on side nav
				$chaptersContainer
					.find(".chapter")
					.not(".no-chapter")
					.each(function (i) {
						if ($(this).offset().top <= windowTopPosition + 280) {
							$navLink.removeClass("active");
							$navLink.eq(i).addClass("active");
						}
					});

				// push menu down (mobile)
				var $menuHeight = $container.outerHeight() - 60;
				$container.css("bottom", -$menuHeight);
			};

			// Nav clicks, scroll function
			$navLink.click(function (e) {
				e.preventDefault();

				var target = this.hash;
				var $target = $(target);

				scrollToPosition($target, target);

				// delayed focus for keyboard users
				if ($("html").is(".keyboard-user")) {
					setTimeout(function () {
						$target.focus();
					}, 1000);
				}

				// mobile menu, scroll back down
				if (window.matchMedia("(max-width: 959px)").matches) {
					closeMenu();
				}
			});

			// Page smooth scroll to position, update location hash
			function scrollToPosition(target, hash) {
				var $target = target;
				var $hash = hash;

				$("html, body")
					.stop()
					.animate(
						{
							scrollTop: $target.offset().top - menuPosition,
						},
						500,
						"swing",
						function () {
							history.pushState(null, null, $hash);
						}
					);
			}

			// make first option active
			$container.find("ul > li:first-child > a").addClass("active");

			stickyNavTop = $chapteredNav.offset().top - offset;

			$window.on("scroll." + namespace, set_nav_position);
			set_nav_position();

			$window.on("resize." + namespace, function () {
				//if (!Modernizr.touchevents) {
				set_nav_position();
				//}
			});

			// click icon, toggle search
			$menuToggle.on("click", function (e) {
				e.preventDefault();

				if (!$(this).is(".active")) {
					openMenu();
				} else {
					closeMenu();
				}
			});

			// mobile: open menu function
			function openMenu() {
				$menuToggle.addClass("active").attr({ "aria-expanded": "true", "aria-label": "Hide Jump To Menu" });
				$container.css("bottom", 0);
			}

			// mobile: close menu function
			function closeMenu() {
				$menuToggle.removeClass("active").attr({ "aria-expanded": "false", "aria-label": "Display Jump To Menu" });
				var $menuHeight = $container.outerHeight() - 60;
				$container.css("bottom", -$menuHeight);
			}

			// display mobile nav on load (FOUC)
			setTimeout(function () {
				$container.css("visibility", "visible");
			}, 300);
		};

		if ($chapteredNav.length) {
			self.init();
		}
	})(jQuery);

	// Juicer Mobile Menu
	UNC.filtersMenu = (function () {
		var init = function () {
			var $filtersToggle = $("section.juicer_feed .filters-toggle");
			var $filtersMenu = $(".juicer-feed .filters");
			var $filtersMenuItem = $(".juicer-feed .filters > li");

			// push menu down (mobile)
			var $menuHeight = $filtersMenu.outerHeight();
			$filtersMenu.css("bottom", -$menuHeight);

			// click icon, toggle search
			$filtersToggle.on("click", function (e) {
				e.preventDefault();

				if (!$filtersMenu.is(".active")) {
					openMenu();
				} else {
					closeMenu();
				}
			});

			// Nav clicks, close menu, re-init
			$filtersMenuItem.click(function (e) {
				e.preventDefault();
				closeMenu();

				setTimeout(function () {
					init();
				}, 500);
			});

			// mobile: open menu function
			function openMenu() {
				$filtersToggle.css("bottom", $menuHeight).addClass("active").attr({ "aria-expanded": "true", "aria-label": "Hide Social Media Filters" });
				$filtersMenu.addClass("active").css("bottom", 0);
			}

			// mobile: close menu function
			function closeMenu() {
				$filtersToggle.css("bottom", 0).removeClass("active").attr({ "aria-expanded": "false", "aria-label": "Display Social Media Filters" });
				var $menuHeight = $filtersMenu.outerHeight();
				$filtersMenu.removeClass("active").css("bottom", -$menuHeight);
			}
		};

		if (window.matchMedia("(max-width: 619px)").matches) {
			if ($("section.juicer_feed").length) {
				setTimeout(function () {
					self.init();
				}, 500);
			}
		}
	})(jQuery);

	/**
	 * Drawers: Show or hide on handle click
	 *
	 * @since   1.0.0
	 */
	$(document).on("click", ".drawers", function (e) {
		e.preventDefault();

		// Don't do anything if the viewport is larger than the drawer's data-viewport size
		var unc_viewport_size = typeof $(this).closest(".drawers").data("viewport") !== undefined ? $(this).closest(".drawers").data("viewport") : 620;
		if (window.innerWidth > unc_viewport_size) {
			return;
		}

		// Show or hide drawers
		if ($(this).hasClass("open")) {
			// Close
			$(this).attr("aria-expanded", false).removeClass("close").removeClass("open");
			$(".fields", $(this).parent()).attr("aria-hidden", true).removeClass("show");
			$(".drawer", $(this).parent()).attr("aria-hidden", true).addClass("visually-hidden");
			$(".handle").removeClass("close");
			// Make sure page is at top
			$("html, body").animate({ scrollTop: 0 }, 200);
		} else {
			// Open
			$(this).attr("aria-expanded", true).addClass("open").addClass("close");
			$(".fields", $(this).parent()).attr("aria-hidden", false).addClass("show");
			$(".drawer", $(this).parent()).attr("aria-hidden", false).removeClass("visually-hidden");
			$(".handle").addClass("close");
		}
	});

	/**
	 * Drawers: Update selected class on click
	 *
	 * @since   1.0.0
	 */
	$(document).on("click", ".drawer a", function (e) {
		// Remove selected class from all links in this drawer
		$("a", $(this).closest(".drawers")).removeClass("selected");

		// Add selected class to the clicked link
		$(this).addClass("selected");
	});

	/**
	 * Drawers: Update selected class on scroll
	 *
	 * @since  1.0.0
	 */
	$(document).on("scroll", function () {
		// Iterate through all drawer links, to see if its element ID is displayed
		$(".drawer.update-on-scroll a").each(function () {
			var element = $(this).attr("href");

			if ($(element).position().top <= $(document).scrollTop() && $(element).position().top + $(element).height() > $(document).scrollTop()) {
				// Add selected class to the clicked link
				$(this).addClass("selected");
			} else {
				// Remove selected element from this class
				$(this).removeClass("selected");
			}
		});

		// window vars
		var $window = $(window);
		var windowHeight = $window.height();
		var windowTopPosition = $window.scrollTop();
		var windowBottomPosition = windowTopPosition + windowHeight;

		// drawers vars
		var $drawers = $(".drawers");

		// footer vars
		var $footer = $("footer#footer");
		var footerHeight = $footer.outerHeight();
		var footerTopPosition = $footer.offset().top;
		var footerBottomPosition = footerTopPosition + footerHeight;

		// add/remove class when footer is visible
		if (footerBottomPosition >= windowTopPosition && footerTopPosition <= windowBottomPosition) {
			$drawers.addClass("over-footer");
		} else {
			$drawers.removeClass("over-footer");
		}
	});

	/**
	 * Drawers: Show or hide on viewport resize
	 *
	 * @since   1.0.0
	 */
	$(window).on("resize", function (e) {
		// Iterate through drawers
		$(".drawers").each(function () {
			// If the viewport exceeds the drawer's activate state, show drawers
			var unc_viewport_size = typeof $(this).data("viewport") !== undefined ? $(this).data("viewport") : 620;
			if (window.innerWidth > unc_viewport_size) {
				// Show all drawers
				$(".drawers .drawer").attr("aria-hidden", false).removeClass("visually-hidden");
			} else {
				// Determine whether to show or hide drawers
				if ($(".handle", $(this)).hasClass("open")) {
					// Drawers were previously closed, so close them again
					$(".drawer", $(this)).attr("aria-hidden", true).addClass("visually-hidden");
					$(this).attr("aria-expanded", false);
				} else {
					// Drawers were previously open, so open them again
					$(".drawer", $(this)).attr("aria-hidden", false).removeClass("visually-hidden");
					$(this).attr("aria-expanded", true);
				}
			}
		});
	});

	/**
	 * Get Tickets
	 *
	 * @since   1.0.0
	 */
	$("ul.event-actions").each(function () {
		$(".btn-attend-event").on("click", function () {
			$(".arrow-down").toggleClass("arrow-up");
			$(".tickets-content").slideToggle("fast").toggleClass("show");
		});
	});

	/**
	 * Inline Search
	 * - Show Inline Search on Search Button Click
	 *
	 * @since   1.0.0
	 */
	$(document).on("click", "a.search.button", function (e) {
		// Prevent loading the target link
		e.preventDefault();

		// Get search element
		var unc_search_element = $("div.smd-search", $(this).closest("section"));

		// Get Drawers elements
		var unc_drawers_element = $("ul.drawers", $(this).closest("section"));

		// Show the inline search form
		$(unc_search_element).addClass("show").find('input[type="search"]').focus();

		// Hide the search button
		$(this).hide();

		// Hide the nav
		$(unc_drawers_element).find(".drawer").hide();
	});

	/**
	 * Inline Search
	 * - Hide Inline Search on Close Button Click
	 *
	 * @since   1.0.0
	 */
	$(document).on("click", "div.smd-search button.close", function (e) {
		// Prevent default action
		e.preventDefault();

		// Hide the inline search form
		$(this).closest("div.search").removeClass("show");

		// Clear value in the input field
		$("input[type=search]").val("");

		// Show the search button
		$("a.search.button", $(this).closest("section")).show();

		$(this).parents(".search").siblings("ul.drawers").find(".drawer").show();
	});

	/**
	 * Inline Search
	 * - Perform inline search on form submit
	 *
	 * @since   1.0.0
	 */
	$(document).on("submit", "div.smd-search form", function (e) {
		// Prevent default action
		e.preventDefault();

		// Call search function
		unc_inline_search(this);
	});

	/**
	 * Inline Search
	 * - Perform inline search on keyup
	 */
	$(document).on("keyup", "div.smd-search input", function (e) {
		// Call search function
		unc_inline_search(this);
	});

	//hide FAQ when google returns results
	var _elementToFind = "gsc-webResult";
	var _elementFound = false;
	$(document).bind("DOMSubtreeModified", function (evt) {
		if (_elementFound) return;
		if ($("." + _elementToFind).length > 0) {
			$(".search-faq").hide();
			_elementFound = true;
		}
	});
	/**
	 * Main Navigation
	 *
	 * @since   1.0.0
	 */
	var $mainNav = $("#navigation-main-menu");
	var $mainNavToggle = $("#menu-main-menu > li:nth-child(2) > button");
	var $sectionNav = $("#navigation-section-menu");
	var $mainNavMedia = $("header#header div.media");
	var $mainNavVideo = $mainNavMedia.find("video")[0];
	var $mainNavVideoPauseBtn = $mainNavMedia.find(".pause");
	var $mainNavSubMenu = $("#menu-main-menu > li > .sub-menu");
	var $mainNavSubMenuItem = $mainNavSubMenu.find("> li > a");

	var $searchToggle = $("#menu-main-menu > li:nth-child(3) > button");
	var $searchOverlay = $("#search-overlay");
	var $searchSubmit = $("td.gsc-search-button > input.gsc-search-button", $searchOverlay);
	var $searchClear = $(".gsc-clear-button", $searchOverlay);
	var $searchInput = $(".gsc-input", $searchOverlay);
	var $searchForm = $("form", $searchOverlay);

	// Seach Overlay Submit button
	$searchSubmit.off("click").click(function (event) {
		event.preventDefault();
		$searchForm.submit();
	});

	// Search Overlay Clear button
	$searchClear.off("click").click(function (event) {
		event.preventDefault();
		$searchInput.val("");
	});

	// Main Nav Submenu Hover MouseEnter
	$mainNavSubMenuItem.on("mouseenter", function () {
		$(this).parent("li").addClass("active");
		$(this).parent("li").siblings("li").removeClass("active");
	});

	// Main Nav Submenu Hover MouseLeave
	$mainNavSubMenu.on("mouseleave", function () {
		$(this).find("> li").removeClass("active");
	});

	// give aria labels to main nav/search toggle button
	$mainNavToggle.attr({ "aria-expanded": "false", "aria-label": "Display Main Navigation Menu", "aria-haspopup": "true" });
	$searchToggle.attr({ "aria-expanded": "false", "aria-label": "Display Search Menu", "aria-haspopup": "true" });

	/**
	 *  Menu: 960 and above viewports: Show Main Menu on Button Toggle Click
	 */
	$mainNav
		.on("click", "#menu-main-menu > li:nth-child(2) > button[aria-expanded=false]", function (e) {
			// Don't do anything if the viewport is less than the navigation's viewport trigger
			if ($(window).width() < $(this).closest("nav[role=navigation]").data("viewport")) {
				return;
			}

			e.preventDefault();

			// Apply body classes
			$("body").addClass("navigate-open").removeClass("search-open no-scroll");

			// Play Video if not paused with button
			if ($mainNavMedia.length) {
				if (!$mainNavVideoPauseBtn.is(".paused")) {
					$mainNavVideo.play();
				}
			}

			// Show sub menu
			$(this).siblings(".sub-menu").addClass("show");

			// Set this button's aria-expanded=true
			$(this).attr({ "aria-expanded": "true", "aria-label": "Hide Main Navigation Menu" });

			// Show top level close button
			$("#main-menu-close").addClass("show");

			// Show Featured Stories
			$("aside#sticky").addClass("show");

			// Hide Section Menu when 'Navigate' is click
			$("nav#navigation-section-menu").addClass("hide");

			// close search overlay
			$searchOverlay.fadeOut(250);

			// Update search aria
			$searchToggle.attr({ "aria-expanded": "false", "aria-label": "Display Search Menu" });
		})
		.on("keyup", "#menu-main-menu > li > button", function (e) {
			// enter key to focus first menu item
			if (e.keyCode === 13) {
				e.preventDefault();
				$(this).siblings("ul").find(">li:nth-child(2) a").focus();
			}
		});

	/** ]
	 *  Menu: 960 and above viewports: Hide Main Menu on Button Toggle Click
	 */
	$mainNav.on("click", "#menu-main-menu > li:nth-child(2) > button[aria-expanded=true], #main-menu-close", function (e) {
		// Don't do anything if the viewport is less than the navigation's viewport trigger
		if ($(window).width() < $(this).closest("nav[role=navigation]").data("viewport")) {
			return;
		}

		e.preventDefault();

		// Remove body class
		$("body").removeClass("navigate-open search-open");

		// Hide sub menu
		$mainNavToggle.attr({ "aria-expanded": "false", "aria-label": "Display Main Site Navigation" }).siblings(".sub-menu").removeClass("show");

		// Hide close button
		$("#main-menu-close").removeClass("show");

		// Hide Featured Stories
		$("aside#sticky").removeClass("show");

		// Show Section Menu
		$("nav#navigation-section-menu").removeClass("hide");

		// Close search overlay
		$searchOverlay.fadeOut(250);

		// Update search aria
		$searchToggle.attr({ "aria-expanded": "false", "aria-label": "Display Search Menu" });
	});

	/**
	 *  Menu: 960 and above viewports: Show/Hide Subnavs
	 */
	$mainNav.on("click", ".sub-menu .toggle", function (e) {
		// Don't do anything if the viewport is less than the navigation's viewport trigger
		if ($(window).width() < $(this).closest("nav[role=navigation]").data("viewport")) {
			return;
		}

		e.preventDefault();

		// hide all open submenus, change buttons text
		$mainNav.find("ul.sub-menu > li > ul.sub-menu").not(this).removeClass("show open close");
		$mainNav
			.find("ul.sub-menu > li > .toggle")
			.attr("aria-expanded", false)
			.text(function () {
				return $(this).text().replace("Hide", "Display");
			});

		if (!$(this).is(".open")) {
			// Show sub menu, set aria
			$(this).attr("aria-expanded", true).siblings(".sub-menu").addClass("show").find("a").first().focus();
			// Change button text to "Hide"
			$(this).text(function () {
				return $(this).text().replace("Display", "Hide");
			});
		} else {
			// Hide sub menu, set aria
			$(this).attr("aria-expanded", false).siblings(".sub-menu").removeClass("show");

			// Change button text to "Display"
			$(this).text(function () {
				return $(this).text().replace("Hide", "Display");
			});
		}
	});

	/**
	 * Menu: 960 and less viewports: Show Sub Menu on Button Toggle Click
	 */
	$mainNav.on("click", "button[aria-expanded=false]:not(#mobile-main-menu,.menu)", function (e) {
		// Don't do anything if the viewport is greater than the navigation's viewport trigger, as the hover events then deal with this
		if ($(window).width() > $(this).closest("nav[role=navigation]").data("viewport")) {
			return;
		}

		e.preventDefault();

		// fix body
		$("body").addClass("no-scroll navigate-open").removeClass("search-open");

		// Show sub menu
		$("ul.sub-menu", $(this).parent()).first().attr("aria-hidden", false).addClass("show");

		// Set this button's aria-expanded=true
		$(this).attr("aria-expanded", true);

		// Show top level close button
		$("button.close", $(this).closest("nav[role=navigation]")).attr("aria-hidden", false).addClass("show");

		// Hide the parent sub menu, if it exists
		$(this).closest("ul.sub-menu").attr("aria-hidden", true);

		// Match the height of this sub menu to the parent, if the parent is taller
		if ($(this).closest("ul.sub-menu").height() > $("ul.sub-menu", $(this).parent()).height()) {
			$("ul.sub-menu", $(this).parent()).height($(this).closest("ul.sub-menu").height());
		}

		// Match the height of the parent sub menu to this sub menu, if this sub menu is taller
		if ($("ul.sub-menu", $(this).parent()).outerHeight() > $(this).closest("ul").outerHeight()) {
			$(this)
				.closest("ul")
				.outerHeight($("ul.sub-menu", $(this).parent()).outerHeight());
		}

		// Hide Section Menu when 'Navigate' is click
		$("nav#navigation-section-menu").addClass("hide");
	});

	/**
	 * Menu: 960 and less viewports: Hide Sub Menu on Button Toggle Click
	 */
	$mainNav.on("click", "button[aria-expanded=true]:not(.menu), #main-menu-close", function (e) {
		// Don't do anything if the viewport is greater than the navigation's viewport trigger, as the hover events then deal with this
		if ($(window).width() > $(this).closest("nav[role=navigation]").data("viewport")) {
			return;
		}

		e.preventDefault();

		// unfix body
		$("body").removeClass("no-scroll navigate-open search-open");

		// Hide sub menu
		$("ul.sub-menu", $(this).parent()).first().attr("aria-hidden", true).removeClass("show");

		// Set this button's aria-expanded=false
		$mainNavToggle.attr({ "aria-expanded": "false", "aria-label": "Display Main Site Navigation" }).siblings(".sub-menu").removeClass("show");

		// Hide close button
		$("button.close", $(this).closest("nav[role=navigation]")).attr("aria-hidden", true).removeClass("show");

		// Show the parent sub menu, if it exists
		$(this).closest("ul.sub-menu");

		// Show Section Menu
		$("nav#navigation-section-menu").removeClass("hide");

		// close search overlay
		$searchOverlay.fadeOut(250);

		// Update search aria
		$searchToggle.attr({ "aria-expanded": "false", "aria-label": "Display Search Menu" });
	});

	//accessibility fix for closing hamburge nav when clicked out
	$("#main-menu-close").focusin(function () {
		$(".mobile-header-menu-wrapper").removeClass("active");
		$(".mobile-menu-toggle").removeClass("active");
		$("body").removeClass("lock-scrolling");
		//console.log('close me');
	});

	/**
	 * Menu: 960 and less viewports: Hide Sub Menus on Button Sub Menu Close Click
	 */
	$mainNav.on("click", "button.close-sub-menu", function (e) {
		e.preventDefault();

		// Hide this sub menu
		$(this).closest("ul.sub-menu").removeClass("show");

		// Set aria-expanded=false on parent menu's button
		$('a[aria-expanded="true"]', $(this).closest("ul.sub-menu").parent()).attr("aria-expanded", false);
		$('button[aria-expanded="true"]', $(this).closest("ul.sub-menu").parent()).attr("aria-expanded", false);
	});

	/**
	 *  Search Button: 620 and above viewports: Show Search Overlay on Button Click
	 */

	$mainNav.on("click", "#menu-main-menu > li:nth-child(3) > button[aria-expanded=false]", function (e) {
		e.preventDefault();

		// if search page, do nothing
		if (document.location.href.match(/\/search[\/?]/)) {
			// on search page, with navigate open, clicking search button closes overlay
			if ($("body").is(".navigate-open")) {
				$("#main-menu-close").trigger("click");
			}

			return;
		}

		// Update Body Classes
		$("body").addClass("search-open").removeClass("navigate-open no-scroll");

		// Update Main Nav Aria
		$mainNavToggle.attr({ "aria-expanded": "false", "aria-label": "Display Main Site Navigation" }).siblings(".sub-menu").removeClass("show");

		// Show Search Overlay
		$searchOverlay.show();

		// Set this button's aria-expanded=true
		$searchToggle.attr({ "aria-expanded": "true", "aria-label": "Hide Search Menu" });

		// Show top level close button
		$("#main-menu-close").addClass("show");

		// Hide Section Menu when 'Navigate' is click
		$("nav#navigation-section-menu").addClass("hide");

		// Hide Featured Stories
		$("aside#sticky").removeClass("show");

		// Focus input
		$searchInput.focus();
	});

	/**
	 *  Search Button: 620 and above viewports: Hide Search Overlay on Button Click
	 */
	$mainNav.on("click", "#menu-main-menu > li:nth-child(3) > button[aria-expanded=true]", function (e) {
		e.preventDefault();

		// Remove body class
		$("body").removeClass("search-open");

		// Hide close button
		$("#main-menu-close").removeClass("show");

		// Hide Featured Stories
		$("aside#sticky").removeClass("show");

		// Show Section Menu
		$("nav#navigation-section-menu").removeClass("hide");

		// Close search overlay
		$searchOverlay.fadeOut(250);

		// Update search aria
		$searchToggle.attr({ "aria-expanded": "false", "aria-label": "Display Search Menu" });
	});

	/**
	 * Menu: 620 and less viewports: Show / Hide Sub Menu on Main Menu Button Click
	 */
	$mainNav.on("click", "#mobile-main-menu", function (e) {
		e.preventDefault();

		if ($(this).attr("aria-expanded") == "false") {
			// Add body class
			$("body").addClass("navigate-open no-scroll");

			// Hamburger
			$(this).attr({ "aria-expanded": "true", "aria-label": "Hide Main Menu" }).addClass("close");
			// Show Menu
			$("ul.menu", $(this).closest("nav[role=navigation]")).addClass("show");
		} else {
			// Remove body class
			$("body").removeClass("navigate-open no-scroll");

			// Hide all sub menus
			$("ul.sub-menu", $(this).closest("nav[role=navigation]")).removeClass("show");

			// Set aria-expanded=false on all links and buttons
			$('a[aria-expanded="true"]', $(this).closest("nav[role=navigation]")).attr("aria-expanded", false);
			$('button[aria-expanded="true"]', $(this).closest("nav[role=navigation]")).attr("aria-expanded", false);

			// Hamburger
			$(this).attr({ "aria-expanded": "false", "aria-label": "Show Main Menu" }).removeClass("close");
			// Hide menu
			$("ul.menu", $(this).closest("nav[role=navigation]")).removeClass("show");
		}

		// Close search overlay
		$searchOverlay.fadeOut(250);

		// Update search aria
		$searchToggle.attr({ "aria-expanded": "false", "aria-label": "Display Search Menu" });
	});

	/**
	 * Sections Menu
	 */
	$sectionNav.on("click", "button.menu", function (e) {
		e.preventDefault();
		e.stopPropagation();

		if ($(this).attr("aria-expanded") == "false") {
			// Show Menu and focus first element
			$("ul.menu", $(this).closest("nav[role=navigation]")).addClass("show");

			// Focus first item if using keyboard
			if ($("html").is(".keyboard-user")) {
				$("ul.menu", $(this).closest("nav[role=navigation]")).find("li:first-child a").focus();
			}

			// Set aria-expanded=true and label on button
			$(this).attr({ "aria-expanded": "true", "aria-label": "Hide Sections Menu" }).addClass("close");

			$(document).one("click", function () {
				// Hide all sub menus
				$sectionNav.find("ul.sub-menu").removeClass("show");

				// Hide menu
				$sectionNav.find("ul.menu").removeClass("show");

				// Set aria-expanded=false on hamburger menu button
				$sectionNav.find("button.menu").attr({ "aria-expanded": "false", "aria-label": "Show Sections Menu" }).removeClass("close");
			});
		} else {
			// Hide all sub menus
			$("ul.sub-menu", $(this).closest("nav[role=navigation]")).removeClass("show");

			// Hide menu
			$("ul.menu", $(this).closest("nav[role=navigation]")).removeClass("show");

			// Set aria-expanded=false on hamburger menu button
			$(this).attr({ "aria-expanded": "false", "aria-label": "Show Sections Menu" }).removeClass("close");
		}
	});

	/**
	 * Navigation: Fix / Unfix on Scroll
	 */
	var set_sticky_nav = function () {
		//console.log('sticky?');
		if (window.matchMedia("(min-width:960px)").matches) {
			// If window scroll position exceeds the top position of the header, fix the nav
			if ($(window).scrollTop() >= $("header#header .header").outerHeight()) {
				$("#navigation").addClass("fixed");
				$("#main").addClass("menu-padding");
			} else {
				$("#navigation").removeClass("fixed");
				$("#main").removeClass("menu-padding");
			}
		}
	};

	// init
	set_sticky_nav();

	// on scroll
	$(window).on("scroll", set_sticky_nav);

	$(window).on("resize", function () {
		//if (!Modernizr.touchevents) {
		set_sticky_nav();
		//}
	});

	/**
	 * Sticky Navigation on Scroll
	 * - Polyfill to support IE9+
	 */
	if (/MSIE|Trident|Edge/.test(navigator.userAgent)) {
		$(".sticky-on-scroll").Stickyfill();
	}

	/**
	 * Sidebar Fixed Navigation on Scroll
	 * - Store original positions of elements
	 */
	$(".fixed-on-scroll").each(function (i) {
		unc_fixed_on_scroll[i] = $(this).offset().top;
	});
	$(window).on("scroll", function (e) {
		// For each fixed on scroll element, determine whether it should be position:fixed
		// or not.
		$(".fixed-on-scroll").each(function (i) {
			// If the viewport is smaller than the minimum width, don't fix
			if ($(window).width() < $(this).data("viewport")) {
				// Do not fix
				$(this).removeClass("fixed");
				return;
			}

			if (!$(this).hasClass("fixed") && $(window).scrollTop() > unc_fixed_on_scroll[i]) {
				// Fix
				$(this).addClass("fixed");
				return;
			}

			if ($(this).hasClass("fixed") && $(window).scrollTop() <= unc_fixed_on_scroll[i]) {
				// Do not fix
				$(this).removeClass("fixed");
				return;
			}
		});
	});

	/**
	 * Smooth Scrolling with Accessibility support
	 */
	$(document).on("click", 'a[href*="#"]:not([href="#"])', function () {
		// Bail if this isn't a smooth scroll link
		if (!$(this).hasClass("smooth-scroll")) {
			return true;
		}

		// Bail for certain links where smooth scrolling won't work
		if (location.pathname.replace(/^\//, "") !== this.pathname.replace(/^\//, "") || location.hostname !== this.hostname) {
			return true;
		}

		// Get the hash from the element
		var hash = this.hash.slice(1);
		if (hash.length === 0) {
			return true;
		}

		// Attempt to get the target element and set its focus
		var target = unc_focus_element(this);

		// Bail if the target hash couldn't be found
		if (!target) {
			return true;
		}

		// Smooth scroll
		$("html, body").animate(
			{
				scrollTop: target.offset().top,
			},
			1000
		);

		// Prevent any further action
		return false;
	});

	/**
	 * Swiper Carousels
	 * - In Pictures Full-Width module
	 */
	// Show
	$(document).on("click", "section.photo_gallery .swiper-button-next, section.photo_gallery .swiper-button-prev", function (e) {
		e.preventDefault();
		$(".swiper-container", $(this).closest("div.container-photo_gallery")).removeClass("swiper-no-swiping").addClass("full-width");
		$("header.top-level.column", $(this).closest("div.container-photo_gallery")).addClass("hide");
		$("h1.blue-bar, h2.blue-bar, h3, p", $(this).closest("div.container-photo_gallery")).addClass("hidden");
		$(".unc-swiper-button-close", $(this).closest("div.container-photo_gallery")).addClass("show");
		$(".swiper-button-wrapper", $(this).closest("div.container-photo_gallery")).addClass("full-width");
	});
	// Hide
	$(document).on("click", "section.photo_gallery button.swiper-button-close", function (e) {
		e.preventDefault();
		$(".swiper-container").removeClass("full-width").addClass("swiper-no-swiping");
		$("header.top-level.column").removeClass("hide");
		$("h1.blue-bar, h2.blue-bar, h3, p").removeClass("hidden");
		$(".unc-swiper-button-close").removeClass("show");
		$(".swiper-button-wrapper").removeClass("full-width");
	});

	/**
	 * Swiper Carousels
	 * - In Pictures Full-Width module (Display on 620 design)
	 */
	$(window).on("resize", function (e) {
		//show
		$("section.photo_gallery").on("click", "button.btn-open-gallery", function (e) {
			e.preventDefault();
			$(this).addClass("hide");
			$(".swiper-button-wrapper", $(this).closest("div.container-photo_gallery")).addClass("show");
			$(".swiper-container", $(this).closest("div.container-photo_gallery")).removeClass("swiper-no-swiping").addClass("full-width");
			$("header.top-level.column", $(this).closest("div.container-photo_gallery")).addClass("hide");
			$("h1.blue-bar, h2.blue-bar, h3, p", $(this).closest("div.container-photo_gallery")).addClass("hidden");
			$(".unc-swiper-button-close", $(this).closest("div.container-photo_gallery")).addClass("show");
			$(".swiper-button-wrapper", $(this).closest("div.container-photo_gallery")).addClass("full-width");
		});
		// Hide
		$("section.photo_gallery").on("click", "button.swiper-button-close", function (e) {
			e.preventDefault();
			$("button.btn-open-gallery").removeClass("hide");
			$(".swiper-button-wrapper").removeClass("show");
		});
	});

	/**
	 * Swiper Carousels
	 * - In Pictures Full-Width module (Display on 320 design)
	 */
	$(window).on("resize", function (e) {
		$(".swiper-container").each(function () {
			if (window.matchMedia("(max-width: 619px)").matches) {
				// Lets swipe
				$(this).removeClass("swiper-no-swiping");
			} else {
				// Disable swiping
				$(this).addClass("swiper-no-swiping");
			}
		});
	});

	/**
	 * Tabbed Content
	 *
	 * @since   1.0.0
	 */
	$(document).on("click", 'a[role="tab"]', function (e) {
		e.preventDefault();

		// Deselect all tabs
		$('a[role="tab"]', $(this).closest("nav.tabs")).attr("aria-selected", false).removeClass("selected");

		// Select this tab
		$(this).attr("aria-selected", true).addClass("selected");

		// Hide all tab panels
		$('div[role="tabpanel"]').attr("aria-hidden", true).hide();

		// Show this tab's panel
		$("div#" + $(this).attr("aria-controls"))
			.attr("aria-hidden", false)
			.show();
	});

	/**
	 * Tabbed Content: Keyboard Navigation
	 *
	 * @since  1.0.0
	 */
	$(document).on("keydown", 'a[role="tab"]', function (e) {
		// If the enter key was pressed, simulate the click event
		if (e.keyCode === 13) {
			$(this).click();
		}

		// If the left arrow was pressed, set the previous tab as selected
		if (e.keyCode === 37) {
			// Get previous tab
			$('a[role="tab"]', $(this).parent().prev()).click().focus();
		}

		// If the right arrow was pressed, set the next tab as selected
		if (e.keyCode === 39) {
			// Get next tab
			$('a[role="tab"]', $(this).parent().next()).click().focus();
		}
	});

	/**
	 * Toggle: Show or hide elements on button click
	 *
	 * @since   1.0.0
	 */
	$(document).on("click", "button.toggle", function (e) {
		// Show or hide elements
		if ($(this).hasClass("open")) {
			// Open
			$($(this).data("toggle")).attr("aria-hidden", false).removeClass("visually-hidden").addClass("show");
			$(this).removeClass("open").addClass("close");
		} else {
			// Close
			$($(this).data("toggle")).attr("aria-hidden", true).addClass("visually-hidden").removeClass("show");
			$(this).removeClass("close").addClass("open");
		}
	});

	/**
	 * Smooth Scrolling for Experience Header
	 *
	 * @since   1.0.0
	 */
	$(document).on("click", ".scroll-for-more", function (e) {
		e.preventDefault();

		var target = $(this).data("target");
		var $target = $(target);

		$("html, body").stop().animate(
			{
				scrollTop: $target.offset().top,
			},
			500,
			"swing"
		);
	});

	/**
	 * Hide FAQ area when results are on the search page
	 *
	 * @since   1.0.0
	 */
	$(document).on("click", ".gsc-search-button", function () {
		if ($(".gsc-search-button").val()) {
			$(".search-faq").hide();
		}
	});

	/**
	 * Runs any initialization routines once the DOM has loaded - for example,
	 * loading Google Maps, Infinite Scrolling, Swiper Carousels and Video.
	 *
	 * This can be subsequently called after an AJAX call modifies the DOM,
	 * i.e. the Story Experience.
	 *
	 * Any listeners should be bound to $( document ), so that they will work
	 * on both the initial DOM and any injected DOM elements.
	 *
	 * @since   1.0.0
	 */
	$(document).on("unc_init", function () {
		// Fire some events to call the above code on page load
		$(window).trigger("resize");
		$(window).trigger("scroll");

		if (window.matchMedia("(min-width: 960px)").matches) {
			$('nav.tabs a[role="tab"]').first().trigger("click");
		}

		// Initialize Elements
		unc_google_maps_init();
		unc_infinite_scrolling_init();
		unc_swiper_carousels_init();
		unc_video_init();
		unc_date_pickers_init();
	});

	// Trigger the above event, to initialize JS
	$(document).trigger("unc_init");
});

/**
 * Sets the focus on the given element, when it's hijacked using JS
 * (such as an anchored link that we smooth scroll, or a tabbed navigation element)
 *
 * This ensures that the element gets focus and meets accessibility requirements
 *
 * @since 	1.0.0
 *
 * @param 	{object} 	element 	DOM Element
 * @return 	mixed 				false | targeted element
 */
function unc_focus_element(element) {
	// Get the target
	var target = $(element.hash);
	target = target.length ? target : $("[name=" + element.hash.slice(1) + "]");

	// Bail if the target hash couldn't be found
	if (!target.length) {
		return false;
	}

	// Set focus for accessibility
	target.focus();

	// Check target was focused for accessibility
	if (target.is(":focus")) {
		// All OK, nothing more to do
		return target;
	}

	// Try to set focus another way
	target.attr("tabindex", "-1");
	target.focus();
	return target;
}

/**
 * Initialize all Date Pickers
 *
 * @since   1.0.0
 */
function unc_date_pickers_init() {
	// Get jQuery
	var $ = jQuery.noConflict();

	// Bail if dateRangePicker isn't loaded
	if (typeof dateRangePicker === undefined) {
		console.log("not here");
		return false;
	}

	//console.log("there is " + $("div.date-range").length + " element that needs a date range picker");
	// Bail if no elements need a date range picker
	if ($("div.date-range").length === 0) {
		return false;
	}

	// // Iterate through date range picker(s), initializing them
	$("div.date-range").each(function (index) {
		// Initialize Date Picker

		unc_date_pickers[index] = $(this)
			.dateRangePicker({
				autoClose: false,

				// The format to display the date
				format: "Do MMM Y",
				separator: " to ",

				// If we're on a mobile device, force a single month on the date picker
				singleMonth: window.matchMedia("(max-width: 749px)").matches ? true : "auto",
				hoveringTooltip: function () {
					return "";
				},
				showTopbar: false,

				// Called when a date input is clicked; fetches the span value
				// and parses it to get the date range.
				// Note that the format of the <span> text must be yyyy-mm-dd separator yyyy-mm-dd
				getValue: function () {
					return $("span", $(unc_date_pickers[index])).text();
				},

				// Sets the value of the date fields once a date range has been selected
				setValue: function (s, start_date, end_date) {
					// Convert dates to YYYY-MM-DD for the date inputs
					var start_date_formatted = moment(start_date, "Do MMM Y").format("YYYY-MM-DD");
					var end_date_formatted = moment(end_date, "Do MMM Y").format("YYYY-MM-DD");

					// Set start and end date on date inputs using the formatted values above
					$("input.start_date", $(unc_date_pickers[index])).attr("value", start_date_formatted);
					$("input.end_date", $(unc_date_pickers[index])).attr("value", end_date_formatted);

					// Display date range, using format and separator
					$("span", $(unc_date_pickers[index])).text(start_date + " to " + end_date);
				},
			})
			.bind("datepicker-open", function () {
				// Define the offset, depending on the device
				var offset = window.matchMedia("(max-width: 749px)").matches ? 261 : 80;

				// Adjust the position of the date picker wrapper
				$(".date-picker-wrapper").css({
					top: "" + ($(".events-filter").offset().top + offset) + "px",
				});

				// Display the Clear All Button
				$(".date-picker-wrapper").on("click", function () {
					$(".clear-all").addClass("show");
				});
			});
	});
}

/**
 * Initialize all Google Maps
 *
 * @since   1.0.0
 */
function unc_google_maps_init() {
	// Get jQuery
	var $ = jQuery.noConflict();

	// Bail if no Google Maps exist
	if ($("div.google-map").length == 0) {
		return false;
	}

	// Define the zoom level you want to use.  This may be overriden if, after plotting all markers on a map,
	// the Google Maps API determines that moving to the given zoom level would result in some markers
	// not being displayed on screen.
	var unc_google_maps_desired_zoom_level = 16;

	// For each Google Map, initialize it
	$("div.google-map").each(function (i) {
		// Copy the unordered list into memory, as this contains the latitude, longitude
		// and marker text that we need
		var unc_google_maps_data = $("ul", $(this));

		// Custom zoom
		if ($(this).attr("zoom") !== "undefined") {
			unc_google_maps_desired_zoom_level = $(this).data("zoom");
		}

		// Define new map
		unc_google_maps[i] = new google.maps.Map(this, {
			zoom: unc_google_maps_desired_zoom_level,
			scrollwheel: false,
			clickableIcons: false,

			// Position controls in the top right corner, so they're not hidden by overlays
			mapTypeControlOptions: {
				position: google.maps.ControlPosition.TOP_RIGHT,
			},
		});

		$(window).on("resize." + i, function () {
			unc_google_maps[i].fitBounds(unc_google_maps_bounds[i]);

			// Get the map center
			unc_google_maps_center[i] = unc_google_maps[i].getCenter();

			if (window.innerWidth > unc_viewport_size) {
				unc_google_maps[i].panBy(-200, 0);
			}
		});

		// Add markers to map by iterating through the list
		(unc_google_maps_markers[i] = []), (unc_google_maps_info_windows[i] = []), (unc_google_maps_bounds[i] = new google.maps.LatLngBounds());

		$("li", $(unc_google_maps_data)).each(function (j) {
			// Add marker to map
			unc_google_maps_markers[i][j] = new google.maps.Marker({
				position: {
					lat: Number($(this).data("latitude")),
					lng: Number($(this).data("longitude")),
				},
				map: unc_google_maps[i],
				icon: unc.google_maps_icon,
			});

			// Add marker's lat/lng position to bounding box
			unc_google_maps_bounds[i].extend(unc_google_maps_markers[i][j].getPosition());

			// Build content
			var content = '<div class="google-map-infowindow"><h4>' + unc.google_maps_infowindow_title + "</h4><p>" + $(this).data("address") + "</p></div>";

			// Add info window to map
			unc_google_maps_info_windows[i][j] = new google.maps.InfoWindow({
				content: content,
				pixelOffset: new google.maps.Size(170, 0),
				maxWidth: 300,
			});

			// Add listener to add some CSS classes to the info window when it is ready
			google.maps.event.addListener(unc_google_maps_info_windows[i][j], "domready", function () {
				// Add class to outer container
				$(".gm-style-iw").parent().addClass("gm-style-iw-outer");
				$("div:first-child > div:first-child", $(".gm-style-iw").parent()).addClass("gm-arrow-shadow");
				$("div:first-child > div:nth-child(3)", $(".gm-style-iw").parent()).addClass("gm-arrow");

				// Add class to the close button
				$("div", $(".gm-style-iw").parent()).last().addClass("gm-style-iw-close");
			});

			// Add listener to display info window when this marker is clicked
			unc_google_maps_markers[i][j].addListener("click", function () {
				// Close any existing infowindows that are open
				for (var loop = 0; loop < unc_google_maps_info_windows[i].length; loop++) {
					unc_google_maps_info_windows[i][loop].close();
				}

				var unc_viewport_size = typeof $(".mobile-google-map").data("viewport") !== undefined ? $(".mobile-google-map").data("viewport") : 620;

				if (window.innerWidth <= unc_viewport_size) {
					$(".mobile-google-map").html(unc_google_maps_info_windows[i][j].content);
				} else {
					unc_google_maps_info_windows[i][j].open(unc_google_maps[i], unc_google_maps_markers[i][j]);
				}
			});
		});

		// Fit the map to the bounding box
		// This overrides the map zoom value
		unc_google_maps[i].fitBounds(unc_google_maps_bounds[i]);

		// Get the map center
		unc_google_maps_center[i] = unc_google_maps[i].getCenter();

		// Open the first marker automatically, if one exists
		var unc_viewport_size = typeof $(".mobile-google-map").data("viewport") !== undefined ? $(".mobile-google-map").data("viewport") : 620;
		if (unc_google_maps_info_windows[i].length > 0 && window.innerWidth <= unc_viewport_size) {
			$(".mobile-google-map").html(unc_google_maps_info_windows[i][0].content);
		} else {
			unc_google_maps_info_windows[i][0].open(unc_google_maps[i], unc_google_maps_markers[i][0]);
		}

		// Set the Zoom and Pan after fitBounds.  If we don't do this, the zoom property
		// on the map is never used, and some markers will be covered by the div overlay
		google.maps.event.addListenerOnce(unc_google_maps[i], "idle", function () {
			if (unc_google_maps[i].getZoom() > unc_google_maps_desired_zoom_level) {
				unc_google_maps[i].setZoom(unc_google_maps_desired_zoom_level);
			}

			// Pan map to the right by 200px, if we're on desktop
			if (window.innerWidth > unc_viewport_size) {
				unc_google_maps[i].panBy(-200, 0);
			}
		});
	});
}

/**
 * Initializes all Infinite Scroll instances
 *
 * @since  1.0.0
 */
function unc_infinite_scrolling_init() {
	// Get jQuery
	var $ = jQuery.noConflict();

	// Bail if jscroll isn't loaded
	if (typeof jscroll === undefined) {
		return false;
	}
	var $infiniteScroll = $(".infinite-scroll");
	// Bail if no Infinite Scroll instances are needed
	if ($infiniteScroll.length === 0) {
		return false;
	}

	// Initialize each Infinite Scroll instance
	$infiniteScroll.each(function (i) {
		// Get configuration from data-attributes
		unc_infinite_scrollers[i] = $(this).jscroll({
			autoTrigger: $(this).data("auto-trigger"),
			autoTriggerUntil: $(this).data("auto-trigger-until"),
			contentSelector: $(this).data("content-selector"),
			debug: $(this).data("debug"),
			loadingHtml: '<div class="unc-loader" aria-label="' + $(this).data("aria-label") + '"></div>',
			nextSelector: $(this).data("next-selector"),

			// Remove previous button
			callback: function (selector) {
				var params = selector.split(" ");
				$("a.prev", $(params[1])).remove();
			},
		});
	});
}

/**
 * Searches DOM elements, showing or hiding them if they match the search
 * terms in the inline search form.
 *
 * @since 	1.0.0
 *
 * @param 	{object} 	ele 	Form or Input Element
 */
function unc_inline_search(ele) {
	// Get jQuery
	var $ = jQuery.noConflict();

	// Get search elements and search terms
	var search_form = $(ele).closest("form"),
		search_elements = $(search_form).data("search-elements"),
		search_terms = $("input", $(search_form)).val();

	// Update the tab interface, depending on the search term length
	// If the value is blank, restore the tab display back to how it was prior to searching
	if (search_terms.length === 0) {
		// Activate the previously active tab
		$(unc_active_tab).attr("aria-selected", true).addClass("selected");

		// Trigger the click event on the tab, which will deal with hiding elements etc.
		$(unc_active_tab).trigger("click");

		// Hide every searchable element
		$(search_elements).attr("aria-hidden", true);

		// Close every searchable element
		$(search_elements).removeAttr("open");
	} else {
		// Get active tab, so we can reactivate this tab if the search is cleared
		if ($("nav ul li a.selected", $(search_form).closest("section")).length > 0) {
			unc_active_tab = $("nav ul li a.selected", $(search_form).closest("section"));
		}

		// Deactivate all tabs
		$("nav ul li a", $(search_form).closest("section")).attr("aria-selected", false).removeClass("selected");

		// Display every tab area and search elements
		$("div.tab", $(search_form).closest("section")).attr("aria-hidden", false).show();

		// Display every searchable element
		$(search_elements).attr("aria-hidden", false);

		// Open every searchable element
		$(search_elements).attr("open", "open");
	}

	// Iterate through each item, displaying or hiding it
	$(search_elements).each(function () {
		// If the text of this item contains the search_terms, display the element
		if ($(this).text().toLowerCase().search(search_terms.toLowerCase()) >= 0) {
			// Show
			$(this).removeClass("hidden");
		} else {
			// Hide
			$(this).addClass("hidden");
		}
	});
}

/**
 * Juicer Feed: Add Featured Posts label on load
 *
 * @since   1.0.0
 */
function unc_juicer_feed_loaded() {
	// Get jQuery
	var $ = jQuery.noConflict();

	// Bail if we already added the Featured Posts handle
	if ($(".juicer-feed ul.filters li.label").length > 0) {
		return false;
	}

	// Add Handle
	$(".juicer-feed ul.filters").prepend('<li class="label">' + unc.juicer_handle_label + "</li>");
}

/**
 * Initialize Swiper Carousels
 *
 * @since   1.7.0
 * updated to use swiper 9.2.3
 */
function unc_swiper_carousels_init() {
	// Get jQuery
	var $ = jQuery.noConflict();

	// Swiper Carousels
	$(".swiper-container").each(function (i) {
		$(this).attr("aria-live", "polite");
		var unc_swiper_next_button = $(".swiper-button-next");
		var unc_swiper_prev_button = $(".swiper-button-prev");

		unc_swipers[i] = new Swiper($(this)[0], {
			loop: true,
			simulateTouch: true,
			slidesPerView: "auto",
			watchSlidesProgress: true,
			keyboard: {
				enabled: true,
				onlyInViewport: false,
			},
			on: {
				transitionEnd: function () {
					/**
					 * Accessibility: Set tabindex and aria-hidden attributes on slide change
					 */
					//console.log('transitionEnd');
					$(".swiper-slide-visible:not(.swiper-slide-prev, .swiper-slide-next)").attr("aria-hidden", "false").find("a, button, iframe").attr("tabindex", "0");

					$(".swiper-slide:not(.swiper-slide-visible)").attr("aria-hidden", "true").find("a, button, iframe").attr("tabindex", "-1");

					// if thumbnails don't exist in slide, add "black" class to title of column
					if ($(".content_carousel").length) {
						$(".swiper-slide-visible").each(function () {
							var $tag = $(this).parents("li.posts, li.social-media").find("h3.title");

							if (!$(this).is(".has-post-thumbnail")) {
								$tag.addClass("black");
							} else {
								$tag.removeClass("black");
							}

							// social don't have thumbnail class, so do logic here
							if ($(this).is(".social")) {
								if ($(this).has(".image").length > 0) {
									$tag.removeClass("black");
								}
							}
						});
					}
				},
			},
			// Navigation arrows
			navigation: {
				nextEl: unc_swiper_next_button[0],
				prevEl: unc_swiper_prev_button[0],
			},
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				type: "bullets",
				renderBullet: function (index, className) {
					/**
					 * Accessibility: Render pagination bullets as <li> with <button>s
					 */
					// Render as <li> instead of the default <span>
					return '<li class="' + className + '"><button>Display Slide ' + (index + 1) + "</button></li>";
				},
			},
		});
	});
}

/**
 * Initialize Self-Hosted Videos
 *
 * @since   1.0.0
 */
function unc_video_init() {
	// Get jQuery
	var $ = jQuery.noConflict();

	$("button.hosted.video.play").attr("aria-hidden", false).addClass("show");
	$("video").each(function () {
		$(this).removeAttr("control");
	});
}

// Responsive Tables, Use data attribute
UNC.respsonsiveTables = (function ($) {
	function init() {
		var $table = $("section.post table, section.tabbed_content table, section.chaptered_page table");

		$table.each(function () {
			var headertext = [];
			var $headers = $(this).find("tr:first-child td, tr:first-child th");
			var $tableRow = $(this).find("tr");

			$headers.each(function (i) {
				headertext.push($(this).text());
			});

			$tableRow.each(function () {
				$(this)
					.find("td")
					.each(function (i) {
						$(this).attr("data-label", headertext[i]);
					});
			});
		});
	}

	if ($("section.post table, section.tabbed_content table, section.chaptered_page table").length) {
		init();
	}
})(jQuery);

// Post Videos, iframes in posts, add wrapper to give 16:9 aspect ratio
// but not all iframes are videos as the original devs though
// some iframes are just iframes, 
// we try to only wrap the iframes if the src is in the videoWrappables array
UNC.postVideos = (function ($) {
	function init() {
		var $videoEmbed = $("section.post .content iframe");
		const videoWrappables = [ 'youtube.com','google.com/maps','unc.photoshelter.com']
		var wrap = false;

		//loop through the wrappable src urls
		videoWrappables.forEach( url => {
			if( $videoEmbed.attr('src').includes(url) ){
				wrap = true;
			}
		});

		//if this is wrappable we should wrap it
		if( wrap === true ){
			$videoEmbed.each(function () {
				$(this).wrap('<div class="video-embed"></div>');
			});
		}
	}

	if ($("section.post .content iframe").length) {
		init();
	}
})(jQuery);
